import React, { Component } from 'react'
import { Link } from 'react-router-dom';

export default class TopMenu extends Component {
  render() {
    const userId = localStorage.getItem('EmployeeName');
    const { heading } = this.props;  // receive heading prop

    return (
      <div>
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars" /></a>
            </li>
            {/* Add heading here */}
            <li
              className="nav-item d-none d-sm-inline-block"
              style={{
                display: 'flex',
                alignItems: 'center', 
                marginTop: '5px'      
              }}
            >
              <span
                style={{
                  fontWeight: '600',
                  fontSize: '20px',
                  // color: '#1C4481',
                  userSelect: 'none'
                }}
              >
                {heading}
              </span>
            </li>

          </ul>
          <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown"></li>
            <li className="nav-item dropdown">
              <a className="nav-link" data-toggle="dropdown" href="#">
                <i className="fas fa-user" /> <span>{userId}</span>
              </a>
              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span className="dropdown-item dropdown-header"></span>
                <div className="dropdown-divider" />
                <Link to="/Profile" className="dropdown-item">
                  <i className="fas fa-users mr-2" /> User Profile
                </Link>
                <div className="dropdown-divider" />
                <Link to="/" className="dropdown-item">
                  <i className="fas fa-user mr-2" /> Log Out
                </Link>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}
